'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sjs_reflect_Reflect$() {
  this.NC = null;
  $n_sjs_reflect_Reflect$ = this;
  this.NC = $j_java$002elang$002e$002dObject.$ct_scm_HashMap__(new $j_java$002elang$002e$002dObject.$c_scm_HashMap());
  $j_java$002elang$002e$002dObject.$ct_scm_HashMap__(new $j_java$002elang$002e$002dObject.$c_scm_HashMap());
}
export { $c_sjs_reflect_Reflect$ as $c_sjs_reflect_Reflect$ };
$p = $c_sjs_reflect_Reflect$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sjs_reflect_Reflect$;
/** @constructor */
function $h_sjs_reflect_Reflect$() {
}
export { $h_sjs_reflect_Reflect$ as $h_sjs_reflect_Reflect$ };
$h_sjs_reflect_Reflect$.prototype = $p;
var $d_sjs_reflect_Reflect$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sjs_reflect_Reflect$, "scala.scalajs.reflect.Reflect$", ({
  vZ: 1
}));
export { $d_sjs_reflect_Reflect$ as $d_sjs_reflect_Reflect$ };
var $n_sjs_reflect_Reflect$;
function $m_sjs_reflect_Reflect$() {
  if ((!$n_sjs_reflect_Reflect$)) {
    $n_sjs_reflect_Reflect$ = new $c_sjs_reflect_Reflect$();
  }
  return $n_sjs_reflect_Reflect$;
}
export { $m_sjs_reflect_Reflect$ as $m_sjs_reflect_Reflect$ };
